import { alertDanger } from '../../globals/alerts'
import { getEditorBySelector } from '../ckEditor'
import { headers } from '../helpers/apiHelpers'
import { showElement } from '../helpers/show'
import { gettext } from '../translation'

/**
 * setup all events for generating test data
 */
export function setupTestDataGeneratorEvents() {
	document.querySelectorAll('.generateTestData').forEach((element) => {
		showElement(element)
		element.addEventListener('click', () => {
			requestTestData(element)
		})
	})
}

/**
 * generate test data with faker data from backend
 *
 * @param {HTMLElement} element - The DOM element to process.
 */
export async function requestTestData(element) {
	const inputIdTypeMap = getInputIdTypeMapFromChild(element)

	fetch('/app/api/test/faker/', {
		method: 'POST',
		body: JSON.stringify(inputIdTypeMap),
		headers: headers(),
	})
		.then(async (response) => {
			if (response.status === 200) {
				const json = await response.json()
				fillTestData(json.data)
			} else {
				errorRequestTestData()
			}
		})
		.catch(() => {
			errorRequestTestData()
		})
}

/**
 * generic error message for request test data
 */
function errorRequestTestData() {
	alertDanger(undefined, gettext('Fehler beim Erstellen der Testdaten'), {
		shortDescriptionOnly: true,
	})
}

/**
 * Get dict {element.id/name: element.type/class} from all inputs in the parent of the childInput
 *
 * @param {HTMLElement} childInput - The DOM element to process.
 * @returns {object} inputIdTypeMap - An object mapping input element IDs to their types/classes.
 */
function getInputIdTypeMapFromChild(childInput) {
	const parent = childInput.parentElement
	if (!parent) return {}

	const inputs = parent.querySelectorAll(
		'input:not([type="hidden"]):not([type="file"]):not(.hidden), textarea:not(.hidden), select:not(.hidden)'
	)
	const inputIdTypeMap = {}

	inputs.forEach((element) => {
		const key = element.name || element.id
		if (!key) return

		const classes = element.classList

		if (element.tagName === 'TEXTAREA') {
			inputIdTypeMap[key] = 'textarea'
		} else if (element.tagName === 'SELECT') {
			inputIdTypeMap[key] = 'select'
		} else if (
			classes.contains('datemask') ||
			classes.contains('datepicker-input')
		) {
			inputIdTypeMap[key] = 'date'
		} else if (classes.contains('timemask')) {
			inputIdTypeMap[key] = 'time'
		} else if (
			classes.contains('moneymask') ||
			classes.contains('moneymask-minus')
		) {
			inputIdTypeMap[key] = 'number'
		} else {
			inputIdTypeMap[key] = element.type
		}
	})

	return inputIdTypeMap
}

/**
 * function to fill test data into UI
 *
 * @param {object} data - the data containing the faker values for each input
 */
function fillTestData(data) {
	Object.entries(data).forEach(([id, value]) => {
		let element = document.getElementById(id)
		if (!element) {
			const elements = document.getElementsByName(id)
			if (elements.length > 0) {
				element = elements[0]
			}
		}

		if (element) {
			try {
				if (element.tagName === 'INPUT') {
					if ([true, false].includes(value)) {
						element.checked = value
					} else {
						element.value = value
					}
				} else if (element.tagName === 'TEXTAREA') {
					try {
						getEditorBySelector(`#${element.id}`).data.set(value)
					} catch {
						element.value = value
					}
				} else if (element.tagName === 'SELECT') {
					selectRandomOption(element)
				}
				element.dispatchEvent(new Event('change', { bubbles: true }))
			} catch (error) {
				console.error(`Error filling test data for element ${id}:`, error)
			}
		}
	})
}

/**
 * function to select a random option in a select element
 *
 * @param {HTMLSelectElement} element - the select element to process
 */
function selectRandomOption(element) {
	const options = element.options

	if (options.length === 0) return

	const randomIndex = Math.floor(Math.random() * options.length)
	element.selectedIndex = randomIndex
}
